import ViewPhotosButton from "@components/common/ViewPhotosButton";
import ImageCloudinary from "@components/skeleton/ImageCloudinary";
import MediaAssets from "@components/utils/MediaAssets";
import { RaqPageType } from "@components/utils/constants";
import { IImageComponentResponse } from "@customTypes/componentResponses";
import {
  IAccommodationResponse,
  IActivityResponse,
  ILocationResponse,
  IPackageResponse,
} from "@customTypes/modelResponses";
import useModalScrollFreeze from "hooks/useModalScrollFreeze";
import { useCallback, useMemo, useState } from "react";
import ViewGalleryModal from "../ViewGalleryModal";
import { ImageDefault } from "../utils/Utils";

interface IPackageDesktopPhotosProps {
  data:
    | IAccommodationResponse
    | ILocationResponse
    | IPackageResponse
    | IActivityResponse;
  isSingle: boolean;
  collectionType: RaqPageType;
}

function PackageDesktopPhotos(props: IPackageDesktopPhotosProps): JSX.Element {
  const [viewGallery, setOpenGallery] = useState(false);
  const noImage = useMemo(() => {
    return MediaAssets.getAsset("no_image_found");
  }, [MediaAssets]);

  const primaryImages = useMemo(() => {
    return (
      // @ts-expect-error
      props.data?.Media?.PrimaryImage ||
      // @ts-expect-error
      props.data?.PrimaryImage || [noImage, noImage, noImage, noImage]
    );
  }, [props.data]);

  const allImages: IImageComponentResponse[] = useMemo(() => {
    // @ts-expect-error
    if (props.data?.Media?.Gallery) {
      // @ts-expect-error
      return [...primaryImages, ...props.data.Media.Gallery];
    } else {
      return primaryImages;
    }
  }, [props.data, primaryImages]);

  const onGalleryClick = useCallback(() => {
    setOpenGallery(true);
  }, []);

  useModalScrollFreeze([viewGallery]);

  return (
    <div className="h-full w-full">
      <div className=" relative h-[calc(50%-8px)]">
        <ImageCloudinary
          className="rounded-2xl"
          src={ImageDefault(allImages[1])}
          alt={props.data.Title}
          layout="fill"
          objectFit="cover"
          width="520"
          height="262"
          priority={true}
        />
      </div>
      <div className="relative mt-4 flex h-[calc(50%-8px)] gap-4">
        <div className="relative aspect-square w-[calc(50%-8px)]">
          <ImageCloudinary
            className="rounded-2xl"
            src={ImageDefault(allImages[2])}
            alt={props.data.Title}
            layout="fill"
            objectFit="cover"
            width="300"
            height="262"
            priority={true}
          />
        </div>
        <div className="relative aspect-square w-[calc(50%-8px)]">
          <ImageCloudinary
            className="rounded-2xl"
            src={ImageDefault(allImages[3])}
            alt={props.data.Title}
            layout="fill"
            objectFit="cover"
            width="300"
            height="262"
            priority={true}
          />
        </div>

        <div className="absolute bottom-3 right-[1.75rem] hidden desktop:flex">
          <ViewPhotosButton onClick={onGalleryClick} />
          {viewGallery && (
            <ViewGalleryModal
              viewGallery={viewGallery}
              setOpenGallery={setOpenGallery}
              allImages={allImages}
              title={props.data.Title}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default PackageDesktopPhotos;
